// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import 'babel-polyfill'
import Vue from 'vue'
import App from './App'
import AppData from "@/components/pc/AppData";
import router from './router'
import ElementUI from 'element-ui'
import locale from 'element-ui/lib/locale/lang/ja'
import 'element-ui/lib/theme-chalk/index.css'
import VideoPlayer from 'vue-video-player'
import VueI18n from "vue-i18n";

require('video.js/dist/video-js.css')
require('vue-video-player/src/custom-theme.css')

Vue.use(VideoPlayer)
Vue.use(ElementUI, { locale })
Vue.use(VueI18n);
const i18n = new VueI18n({
    locale: 'ja', // set locale
    messages: require('@/messages/message_console.json'),
    preserveDirectiveContent: true
})
Vue.config.productionTip = false

let store = new AppData(i18n, Vue.prototype.$notify)

/* eslint-disable no-new */
new Vue({
    el: '#app',
    i18n: i18n,
    data: {
        store: store.store
    },
    router,
    template: '<App/>',
    components: { App }
})
